import { gql } from '@apollo/client';

export default gql`
  query syncPageData {
    syncPageData
  }
`; 